import { render, staticRenderFns } from "./CourseActPopup.vue?vue&type=template&id=766261db&"
import script from "./CourseActPopup.vue?vue&type=script&lang=js&"
export * from "./CourseActPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports